/* Nayan Sukh Exclusive — interactions (Dawn) */
(function () {
  'use strict';

  function reveal() {
    /* content is visible by default (see nse.css). Here: mark on-screen sections .is-in instantly,
       hide only BELOW-viewport ones (.nse-out) and animate them in on scroll.
       All reads before all writes — avoids one forced reflow per section. */
    var els = Array.prototype.slice.call(document.querySelectorAll('.nse-reveal:not(.is-in)'));
    if (!els.length) return;
    var vh = window.innerHeight, tops = els.map(function (e) { return e.getBoundingClientRect().top; });
    var below = [];
    els.forEach(function (e, i) {
      if (tops[i] < vh + 60) { e.classList.add('is-in'); }
      else { e.classList.add('nse-out'); below.push(e); }
    });
    if (!below.length) return;
    if (!('IntersectionObserver' in window)) { below.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    below.forEach(function (e) { io.observe(e); });
    setTimeout(function () { document.querySelectorAll('.nse-reveal:not(.is-in)').forEach(function (e) { e.classList.add('is-in'); }); }, 2500);
  }

  function rails() {
    document.querySelectorAll('[data-rail]').forEach(function (btn) {
      if (btn.__b) return; btn.__b = true;
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-rail-scope]') || document;
        var rail = scope.querySelector('.nse-rail'); if (!rail) return;
        var c = rail.firstElementChild; var step = c ? c.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: btn.getAttribute('data-rail') === 'prev' ? -step : step, behavior: 'smooth' });
      });
    });
  }

  /* rail carousels with edge arrows that auto-hide at start/end */
  function carousels() {
    document.querySelectorAll('[data-nse-carousel]').forEach(function (w) {
      if (w.__c) return; w.__c = true;
      var track = w.querySelector('[data-carousel-track]'); if (!track) return;
      var prev = w.querySelector('[data-carousel-prev]'), next = w.querySelector('[data-carousel-next]');
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2, x = track.scrollLeft;
        if (prev) prev.classList.toggle('is-off', x <= 2);
        if (next) next.classList.toggle('is-off', max <= 2 || x >= max);
        if (dotsEl) { var cur = Math.round(x / Math.max(1, track.clientWidth)); [].forEach.call(dotsEl.children, function (d, k) { d.classList.toggle('on', k === cur); }); }
      }
      /* 2x2 pages on phones: arrows move exactly one page; page dots under the row (tap to jump) */
      var paged = track.classList.contains('nse-br__rail--m2x2') && window.matchMedia('(max-width: 749px)').matches;
      var dotsEl = null;
      function pages() { return [].slice.call(track.children).filter(function (p) { return getComputedStyle(p).display !== 'none'; }); /* works inside a hidden tab too */ }
      function nudge(dir) {
        if (paged) { var w = track.clientWidth, i = Math.round(track.scrollLeft / w) + dir; track.scrollTo({ left: Math.max(0, i) * w, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }
      if (paged) {
        var n = pages().length;
        if (n > 1) {
          dotsEl = document.createElement('div'); dotsEl.className = 'nse-br__pdots';
          for (var k = 0; k < n; k++) { (function (k) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Page ' + (k + 1)); b.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); dotsEl.appendChild(b); })(k); }
          track.insertAdjacentElement('afterend', dotsEl);
        }
      }
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* product gallery (main + dots/thumbs) */
  function galleries() {
    document.querySelectorAll('[data-nse-gallery]').forEach(function (g) {
      if (g.__b) return; g.__b = true;
      var slides = [].slice.call(g.querySelectorAll('.nse-gal__slide'));
      var dots = [].slice.call(g.querySelectorAll('.nse-gal__dot'));
      var track = g.querySelector('.nse-gal__track');
      var i = 0;
      function go(n) { i = (n + slides.length) % slides.length; if (track) track.style.transform = 'translateX(' + (-i * 100) + '%)'; dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var x0 = null;
      if (track) {
        track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      }
      g.querySelectorAll('[data-gal="prev"]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
      g.querySelectorAll('[data-gal="next"]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
      go(0);
    });
  }

  /* image lightbox — click/zoom on desktop, pinch-zoom + swipe + one-finger pan on mobile */
  function lightbox() {
    if (window.__nseLb) return; window.__nseLb = true;
    var ov, imgEl, list = [], idx = 0;
    var scale = 1, tx = 0, ty = 0;                 // transform state
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var MAXZ = 4;

    function apply() {
      imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      imgEl.classList.toggle('is-zoom', scale > 1.01);
    }
    function bounds() { // max translate so the image can't be dragged off-stage
      var r = imgEl.getBoundingClientRect();
      return { x: Math.max(0, (r.width - imgEl.clientWidth) / 2 + (imgEl.clientWidth * (scale - 1)) / 2), y: Math.max(0, (imgEl.clientHeight * (scale - 1)) / 2) };
    }
    function clamp() { var b = bounds(); tx = Math.max(-b.x, Math.min(b.x, tx)); ty = Math.max(-b.y, Math.min(b.y, ty)); }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }

    function build() {
      ov = document.createElement('div'); ov.className = 'nse-lb';
      ov.innerHTML =
        '<button class="nse-lb__close" aria-label="Close">&times;</button>' +
        '<button class="nse-lb__nav nse-lb__nav--prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg></button>' +
        '<button class="nse-lb__nav nse-lb__nav--next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '<div class="nse-lb__stage"><img class="nse-lb__img" alt=""></div>';
      document.body.appendChild(ov);
      imgEl = ov.querySelector('.nse-lb__img');
      ov.addEventListener('click', function (e) {
        if (e.target === ov || e.target.classList.contains('nse-lb__stage') || e.target.closest('.nse-lb__close')) close();
      });
      ov.querySelector('.nse-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      ov.querySelector('.nse-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      document.addEventListener('keydown', function (e) { if (!ov.classList.contains('is-open')) return; if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(idx - 1); else if (e.key === 'ArrowRight') show(idx + 1); });

      if (!coarse) {
        // Desktop: click toggles zoom; moving the mouse pans like a magnifier
        imgEl.addEventListener('click', function (e) {
          e.stopPropagation();
          if (scale > 1.01) { reset(); } else { scale = 2.5; magnify(e); }
        });
        imgEl.addEventListener('mousemove', function (e) { if (scale > 1.01) magnify(e); });
      } else {
        bindTouch();
      }
    }
    function magnify(e) {
      var r = imgEl.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width - 0.5;
      var fy = (e.clientY - r.top) / r.height - 0.5;
      var b = bounds();
      tx = -fx * 2 * b.x; ty = -fy * 2 * b.y; apply();
    }
    function bindTouch() {
      var startX = 0, startY = 0, baseTx = 0, baseTy = 0, pinchD = 0, baseScale = 1, mode = '', moved = false;
      function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
      imgEl.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) { mode = 'pinch'; pinchD = dist(e.touches); baseScale = scale; }
        else if (e.touches.length === 1) { mode = scale > 1.01 ? 'pan' : 'swipe'; startX = e.touches[0].clientX; startY = e.touches[0].clientY; baseTx = tx; baseTy = ty; moved = false; }
      }, { passive: true });
      imgEl.addEventListener('touchmove', function (e) {
        if (mode === 'pinch' && e.touches.length === 2) {
          scale = Math.max(1, Math.min(MAXZ, baseScale * dist(e.touches) / pinchD)); clamp(); apply(); e.preventDefault();
        } else if (mode === 'pan' && e.touches.length === 1) {
          tx = baseTx + (e.touches[0].clientX - startX); ty = baseTy + (e.touches[0].clientY - startY); clamp(); apply(); moved = true; e.preventDefault();
        } else if (mode === 'swipe') {
          if (Math.abs(e.touches[0].clientX - startX) > 8) moved = true;
        }
      }, { passive: false });
      imgEl.addEventListener('touchend', function (e) {
        if (mode === 'swipe' && moved) { var dx = (e.changedTouches[0].clientX - startX); if (Math.abs(dx) > 45) show(dx < 0 ? idx + 1 : idx - 1); }
        if (scale <= 1.02) reset();
        if (e.touches.length === 0) mode = '';
      });
    }

    function show(n) { if (!list.length) return; idx = (n + list.length) % list.length; reset(); imgEl.src = list[idx]; ov.querySelectorAll('.nse-lb__nav').forEach(function (b) { b.style.display = list.length > 1 ? '' : 'none'; }); }
    function open(srcs, start) { if (!ov) build(); list = srcs; show(start); ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { if (!ov) return; ov.classList.remove('is-open'); document.body.style.overflow = ''; reset(); }
    document.addEventListener('click', function (ev) {
      var im = ev.target.closest('[data-nse-gallery] .nse-gal__slide img'); if (!im) return;
      var g = im.closest('[data-nse-gallery]');
      var imgs = [].slice.call(g.querySelectorAll('.nse-gal__slide img'));
      var srcs = imgs.map(function (x) { return x.getAttribute('data-full') || x.src; });
      open(srcs, imgs.indexOf(im));
    });
  }

  /* toast */
  var toastEl;
  function toast(msg, href) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'nse-toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span>' + msg + '</span>' + (href ? ' <a href="' + href + '">View bag →</a>' : '');
    toastEl.classList.add('is-show'); clearTimeout(toastEl.__t); toastEl.__t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3500);
  }

  function routes(k) { try { if (window.routes && window.routes[k]) return window.routes[k]; } catch (e) {} return k === 'cart_add_url' ? '/cart/add.js' : '/cart.js'; }

  /* Add items to cart (array of {id,quantity,properties}) + refresh Dawn drawer */
  window.nseAddToCart = function (items, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    var sectionIds = [];
    if (drawer) sectionIds.push('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) sectionIds.push('cart-icon-bubble');
    var body = { items: items };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    return fetch(routes('cart_add_url'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function (res) {
        if (opts.redirect) { window.location.href = opts.redirect; return res; }
        // update sections
        try {
          if (res.sections) {
            if (res.sections['cart-drawer'] && drawer) {
              var html = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
              var inner = html.querySelector('.drawer__inner');
              var cur = drawer.querySelector('.drawer__inner');
              if (inner && cur) cur.innerHTML = inner.innerHTML;
              drawer.classList.remove('is-empty');
            }
            if (res.sections['cart-icon-bubble'] && bubble) {
              var hb = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
              bubble.innerHTML = hb.querySelector('.shopify-section') ? hb.querySelector('.shopify-section').innerHTML : hb.body.innerHTML;
            }
          }
          if (drawer && typeof drawer.open === 'function') { drawer.open(); }
          else { toast('Added to bag', '/cart'); }
        } catch (e) { toast('Added to bag', '/cart'); }
        return res;
      });
  };

  /* delegated quick add-to-cart for cards / buttons */
  function quickAdd() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-nse-atc]'); if (!b) return;
      ev.preventDefault(); if (b.disabled) return;
      var id = b.getAttribute('data-nse-atc'); if (!id) return;
      var orig = b.innerHTML; b.disabled = true; b.style.opacity = '.7';
      window.nseAddToCart([{ id: Number(id), quantity: 1 }]).then(function () { b.disabled = false; b.style.opacity = ''; b.innerHTML = orig; })
        .catch(function () { b.disabled = false; b.style.opacity = ''; b.innerHTML = orig; toast('Could not add to cart'); });
    });
  }

  /* menu drawer: lock the page behind so the drawer (not the page) scrolls */
  function initMenuLock() {
    var det = document.getElementById('Details-menu-drawer-container');
    if (!det || det.__lock) return; det.__lock = true;
    var y = 0;
    det.addEventListener('toggle', function () {
      if (det.open) {
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        y = window.scrollY || window.pageYOffset;
        document.body.style.position = 'fixed';
        document.body.style.top = (-y) + 'px';
        document.body.style.left = '0'; document.body.style.right = '0';
        document.body.style.width = '100%';
        if (sbw > 0) { document.body.style.paddingRight = sbw + 'px'; }
      } else {
        document.body.style.position = '';
        document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.width = ''; document.body.style.paddingRight = '';
        window.scrollTo(0, y);
      }
    });
  }

  /* mobile header search: icon toggles the slim bar under the header; focus right away (inside the tap, so iOS opens
     the keyboard); closes on ✕, Escape, tapping outside, or when the menu drawer opens */
  function mobileSearch() {
    var btn = document.querySelector('[data-nse-msearch-toggle]'), bar = document.querySelector('[data-nse-msearch]');
    if (!btn || !bar || btn.__b) return; btn.__b = true;
    var input = bar.querySelector('input[type="search"]');
    function set(open) {
      bar.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { input.focus(); } else if (bar.contains(document.activeElement)) { document.activeElement.blur(); }
    }
    btn.addEventListener('click', function () { set(!bar.classList.contains('is-open')); });
    bar.querySelector('[data-nse-msearch-close]').addEventListener('click', function () { set(false); btn.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && bar.classList.contains('is-open')) { set(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (bar.classList.contains('is-open') && !bar.contains(e.target) && !btn.contains(e.target)) set(false); });
    var det = document.getElementById('Details-menu-drawer-container');
    if (det) det.addEventListener('toggle', function () { if (det.open) set(false); });
  }

  /* live search suggestions for every input[data-nse-suggest] (header phone bar + desktop inline search).
     Shopify's /search/suggest.json: waits for a typing pause, aborts stale requests, caches per query. Arrow keys + Enter
     pick a result; plain Enter still runs the normal search. Text is set with textContent (never injected as HTML). */
  function searchSuggest() {
    var inputs = document.querySelectorAll('input[data-nse-suggest]');
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var fmt; try { fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 0 }); } catch (e) { fmt = { format: function (n) { return n; } }; }
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function img(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
    Array.prototype.forEach.call(inputs, function (input, n) {
      if (input.__sg) return; input.__sg = true;
      var form = input.form; if (!form) return;
      var panel = el('div', 'nse-suggest'); panel.id = 'NseSuggest-' + n; panel.hidden = true; panel.setAttribute('role', 'listbox');
      form.appendChild(panel);
      input.setAttribute('aria-controls', panel.id); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
      var timer, ctrl, cache = {}, active = -1, last = '';
      function links() { return panel.querySelectorAll('a'); }
      function show(on) { panel.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on) active = -1; }
      function mark(i) { var l = links(); if (!l.length) return; active = (i + l.length) % l.length; for (var k = 0; k < l.length; k++) l[k].classList.toggle('is-active', k === active); l[active].scrollIntoView({ block: 'nearest' }); }
      function allUrl(q) { return form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
      function render(q, r) {
        panel.textContent = ''; active = -1;
        var cols = (r.collections || []).slice(0, 3), prods = r.products || [];
        if (cols.length) {
          panel.appendChild(el('p', 'nse-suggest__h', 'Collections'));
          cols.forEach(function (c) { var a = el('a', 'nse-suggest__col', c.title); a.href = c.url; a.setAttribute('role', 'option'); panel.appendChild(a); });
        }
        if (prods.length) {
          panel.appendChild(el('p', 'nse-suggest__h', 'Products'));
          prods.forEach(function (p) {
            var a = el('a', 'nse-suggest__item'); a.href = p.url; a.setAttribute('role', 'option');
            var src = p.featured_image && p.featured_image.url || p.image;
            if (src) { var i = el('img', 'nse-suggest__img'); i.src = img(src, 112); i.alt = ''; i.width = 56; i.height = 56; i.loading = 'lazy'; a.appendChild(i); }
            var t = el('span', 'nse-suggest__txt');
            if (p.vendor) t.appendChild(el('span', 'nse-suggest__brand', p.vendor));
            t.appendChild(el('span', 'nse-suggest__title', p.title));
            var pr = el('span', 'nse-suggest__price', fmt.format(parseFloat(p.price)));
            var cmp = parseFloat(p.compare_at_price_max); if (cmp > parseFloat(p.price)) pr.appendChild(el('s', '', fmt.format(cmp)));
            t.appendChild(pr); a.appendChild(t); panel.appendChild(a);
          });
        }
        if (!cols.length && !prods.length) panel.appendChild(el('p', 'nse-suggest__empty', 'No matches for \u201c' + q + '\u201d'));
        var all = el('a', 'nse-suggest__all'); all.href = allUrl(q); all.setAttribute('role', 'option');
        all.appendChild(el('span', '', 'See all results for \u201c' + q + '\u201d')); all.appendChild(el('span', '', '\u2192'));
        panel.appendChild(all); show(true);
      }
      function run() {
        var q = input.value.trim(); last = q;
        if (q.length < 2) { show(false); return; }
        if (cache[q]) { render(q, cache[q]); return; }
        if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product,collection&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
          var res = (d.resources && d.resources.results) || {}; cache[q] = res; if (q === last) render(q, res);
        }).catch(function () {});
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && panel.childNodes.length) show(true); });
      input.addEventListener('keydown', function (e) {
        if (panel.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
        else if (e.key === 'Escape') { show(false); }
        else if (e.key === 'Enter' && active > -1) { e.preventDefault(); e.stopImmediatePropagation(); window.location.href = links()[active].href; }
      }, true);
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) show(false); });
    });
  }

  /* lazy-load offscreen videos: fetch + play only when near the viewport, pause when far.
     Cuts the ~25MB of autoplay video that content-heavy pages (brand rows, shop-the-look) would otherwise download up front. */
  function lazyVideos() {
    var vids = document.querySelectorAll('video[data-nse-lazyvideo]');
    if (!vids.length) return;
    function ensureSrc(v) {
      if (v.dataset.nseLoaded) return;
      v.dataset.nseLoaded = '1';
      var srcs = v.querySelectorAll('source[data-src]');
      for (var i = 0; i < srcs.length; i++) { srcs[i].src = srcs[i].getAttribute('data-src'); }
      v.load();
    }
    function play(v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    if (!('IntersectionObserver' in window)) { for (var i = 0; i < vids.length; i++) { ensureSrc(vids[i]); play(vids[i]); } return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { ensureSrc(e.target); play(e.target); }
        else if (e.target.dataset.nseLoaded) { e.target.pause(); }
      });
    }, { rootMargin: '300px 0px' });
    for (var k = 0; k < vids.length; k++) {
      if (!vids[k].__nseObs) { vids[k].__nseObs = 1; io.observe(vids[k]); }
    }
  }

  /* Uniform price fit. Two guarantees the user asked for:
     1) ONE page-wide scale + padding/gap trim (from the worst PRODUCT card), so every card shrinks
        by the identical amount — never one card smaller than its neighbour.
     2) Wrapping is all-or-none PER FAMILY: if, after scaling, any product-card price still can't fit,
        EVERY product card switches to two centred lines together (and likewise for the small video
        chips) — never a page with some one-line and some two-line cards.
     Scale floor 0.85 (below that it stacks instead of shrinking further). The Shop-the-Look card
     (large .nse-vcard) is exempt: it takes the scale but is never stacked/centred.
     Buttons: <=389px CSS slims padding (bag kept); a button that still can't hold one line drops
     its bag — that button only. Re-checks on resize + web-font load. */
  function fitCards() {
    var root = document.documentElement;
    root.style.removeProperty('--nse-price-scale');
    root.style.removeProperty('--nse-price-pad');
    root.style.removeProperty('--nse-price-gap');
    var pRows = [], vRows = [];
    document.querySelectorAll('.nse-pcard__price').forEach(function (r) { if (r.offsetParent) pRows.push(r); });
    document.querySelectorAll('.nse-vcard--sm .nse-vcard__price').forEach(function (r) { if (r.offsetParent) vRows.push(r); });
    pRows.concat(vRows).forEach(function (r) { r.classList.remove('nse-price--stack'); });
    /* scale is driven by product cards only — they can't wrap gracefully inside a small fixed card,
       so shrinking is preferable there; video chips just stack when they overflow at that scale. */
    var scale = 1;
    pRows.forEach(function (r) {
      var need = r.scrollWidth, avail = r.clientWidth;
      if (need > avail + 1) {
        var s = (avail + 15) / (need - 4); /* +16px from padding 14->6 (1px safety), -4px from gap 8->4 */
        if (s < scale) scale = s;
      }
    });
    scale = Math.max(scale, 0.85);
    if (scale < 1) {
      root.style.setProperty('--nse-price-scale', scale.toFixed(3));
      root.style.setProperty('--nse-price-pad', '6px');
      root.style.setProperty('--nse-price-gap', '4px');
    }
    requestAnimationFrame(function () {
      /* re-measure at the applied scale; stack the WHOLE family if any member overflows */
      var pOver = pRows.some(function (r) { return r.scrollWidth > r.clientWidth + 1; });
      if (pOver) pRows.forEach(function (r) { r.classList.add('nse-price--stack'); });
      var vOver = vRows.some(function (r) { return r.scrollWidth > r.clientWidth + 1; });
      if (vOver) vRows.forEach(function (r) { r.classList.add('nse-price--stack'); });
      document.querySelectorAll('.nse-pcard__btn').forEach(function (b) {
        b.classList.remove('nse-pcard__btn--noicon');
        if (b.querySelector('svg') && b.scrollWidth > b.clientWidth + 1) b.classList.add('nse-pcard__btn--noicon');
      });
    });
  }
  var fitT;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitCards, 150); });
  window.addEventListener('load', fitCards); /* re-run once web fonts have settled the metrics */

  /* fitCards is NOT run here: it measures every price row (forcing layout of off-screen sections) and its
     result depends on settled web fonts anyway — it runs on window load, on resize, and on editor section reloads. */
  /* card photo swipe dots: one capture-phase scroll listener for every swipeable card photo */
  function cardDots() {
    if (document.__nseDots) return; document.__nseDots = true;
    document.addEventListener('scroll', function (e) {
      var t = e.target; if (!t.classList || !t.classList.contains('nse-pcard__imgs--swipe')) return;
      var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
      var dots = t.parentNode.querySelectorAll('.nse-pcard__dots i');
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
    }, { capture: true, passive: true });
  }

  /* desktop quick view: [data-nse-qv="handle"] → pop-up with photos, price, add to cart (first available variant, like the
     card's Add button) or "Choose options" for multi-variant products; built on first use, product data from /products/x.js */
  function quickView() {
    if (document.__nseQv) return; document.__nseQv = true;
    var dlg;
    function money(c) { return '\u20b9' + Math.round(c / 100).toLocaleString('en-IN'); }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-nse-qv]'); if (!b) return;
      ev.preventDefault();
      var h = b.getAttribute('data-nse-qv');
      fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.json(); }).then(function (p) {
        if (!dlg) {
          dlg = document.createElement('dialog'); dlg.className = 'nse-qv'; document.body.appendChild(dlg);
          dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        }
        var v = p.variants.filter(function (x) { return x.available; })[0];
        var multi = p.variants.length > 1;
        var imgs = (p.images || []).slice(0, 6);
        dlg.innerHTML = '<div class="nse-qv__in"><button type="button" class="nse-qv__x" aria-label="Close">\u00d7</button>' +
          '<div class="nse-qv__gal"><img class="nse-qv__main" src="' + img(imgs[0], 900) + '" alt="' + esc(p.title) + '">' +
          (imgs.length > 1 ? '<div class="nse-qv__thumbs">' + imgs.map(function (s, i) { return '<button type="button" class="' + (i ? '' : 'on') + '" data-src="' + img(s, 900) + '" aria-label="Photo ' + (i + 1) + '"><img src="' + img(s, 160) + '" alt=""></button>'; }).join('') + '</div>' : '') + '</div>' +
          '<div class="nse-qv__info"><p class="nse-qv__vendor">' + esc(p.vendor) + '</p><h2 class="nse-qv__title">' + esc(p.title) + '</h2>' +
          '<p class="nse-qv__price">' + money(p.price) + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</p>' +
          (v && !multi ? '<button type="button" class="nse-qv__btn" data-nse-atc="' + v.id + '">Add to cart</button>' : '') +
          '<a class="nse-qv__btn' + (v && !multi ? ' nse-qv__btn--ghost' : '') + '" href="' + p.url + '">' + (multi ? 'Choose options' : 'View full details \u2192') + '</a></div></div>';
        dlg.querySelector('.nse-qv__x').addEventListener('click', function () { dlg.close(); });
        dlg.querySelectorAll('.nse-qv__thumbs button').forEach(function (t) {
          t.addEventListener('click', function () {
            dlg.querySelector('.nse-qv__main').src = t.getAttribute('data-src');
            dlg.querySelectorAll('.nse-qv__thumbs button').forEach(function (x) { x.classList.toggle('on', x === t); });
          });
        });
        var atc = dlg.querySelector('[data-nse-atc]'); if (atc) atc.addEventListener('click', function () { setTimeout(function () { dlg.close(); }, 400); });
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      }).catch(function () { location.href = '/products/' + h; });
    });
  }

  function init() { reveal(); rails(); carousels(); galleries(); lightbox(); initMenuLock(); mobileSearch(); searchSuggest(); lazyVideos(); cardDots(); quickView(); }
  window.NSEreinit = function () { reveal(); rails(); carousels(); lazyVideos(); fitCards(); };
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  quickAdd();
  document.addEventListener('shopify:section:load', function () { init(); fitCards(); });
  if (document.readyState === 'complete') fitCards(); /* script ran after load already fired */
})();
